module.exports = __webpack_public_path__ + "static/media/Brainstation.b0c48f9a.png";